const COOKIE_HASH = "ADWISE_ANSLAGSTAVLAN_USER_HASH";
const COOKIE_USER = "ADWISE_ANSLAGSTAVLAN_USER_LOGIN";


export function getUserHash() {
  const hash = getCookieData(COOKIE_HASH);
  const username = getCookieData(COOKIE_USER);

  return {username, hash};
}

export function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export function isAdministrator() {
  const {username, hash} = getUserHash();

  return username === 'adwise'; // Also checked in backend - doh!
}

export function invalidateUser() {
  eraseCookieData(COOKIE_USER);
  eraseCookieData(COOKIE_HASH);
}

export function isAuthenticated() {
  const [username, hash] = getUserHash();
  return (username && hash);
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function setCookieData( name, value ) {
  var pairs = document.cookie.split("; "),
    count = pairs.length, parts;
  let newCookie = name + "=" + value + "; ";
  while ( count-- ) {
    parts = pairs[count].split("=");
    if ( parts[0] !== name )
      newCookie += parts[0] + "=" + parts[1] + "; ";
  }
  document.cookie = newCookie;
}

export function eraseCookieData( name ) {
  var pairs = document.cookie.split("; "),
    count = pairs.length, parts;
  let newCookie = "";
  while ( count-- ) {
    parts = pairs[count].split("=");
    if ( parts[0] !== name )
      newCookie += parts[0] + "=" + parts[1] + "; ";
  }
  document.cookie = newCookie;
}

export function getCookieData( name ) {
  var pairs = document.cookie.split("; "),
    count = pairs.length, parts;
  while ( count-- ) {
    parts = pairs[count].split("=");
    if ( parts[0] === name )
      return parts[1];
  }
  return false;
}
